import React from "react";
import AddWorkflowComponent from "../features/workflows-page/addWorkflow/AddWorkflow";

function AddWorkflow() {
  return (
    <>
      <AddWorkflowComponent />
    </>
  );
}

export default AddWorkflow;
